<template>
    <div>
        <v-card class="pa-0 pb-5 elevation-0">
            <canvas id="chart3" ref="chart3" height="500"></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            labels: [],
            approvalRates: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    methods: {
        render() {
        

            console.log(this.chartData);
            
            this.labels = this.chartData.map(e => `${e.timeFrom} - ${e.timeTo}`);
            this.approvalRates = this.chartData.map(e => parseFloat(e.approvalRate));

            this.canvas = this.$refs['chart3'].getContext('2d');
            let chartData = { datasets: [] };
            chartData.datasets.push({ label: 'Value',
                                      data: this.approvalRates,
                                      borderColor: 'rgb(66, 165, 245)',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(66, 165, 245, 0.3)",
                                      pointBackgroundColor: "rgb(66, 165, 245)",
                                      pointHoverBackgroundColor: "rgb(66, 165, 245)",
                                      pointRadius: 4,
                                      pointHoverRadius: 6 });

            this.chart = new Chart(this.canvas, {
                type: 'polarArea',
                data: {
                    labels: this.labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                 
                    legend: {
                        display: false,
                        labels: {
                            fontSize: 10,
                            fontColor: '#FFF',
                            usePointStyle: true
                        },
                        position: 'bottom'
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltip) {
                                return `${tooltip.value}%`;
                            },
                            title: function(tooltipItem, data) {
                                return data['labels'][tooltipItem[0]['index']];
                            },
                         }
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>